import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

function bannerHeaderInlineStyleContainer(_ref) {
  var _ref$layout = _ref.layout,
      type = _ref$layout.type,
      dialogBorderRadius = _ref$layout.dialogBorderRadius,
      _ref$design = _ref.design,
      borderWidth = _ref$design.borderWidth,
      borderColor = _ref$design.borderColor,
      restDesign = _objectWithoutProperties(_ref$design, ["borderWidth", "borderColor"]),
      _ref$headerDesign = _ref.headerDesign,
      inheritBg = _ref$headerDesign.inheritBg,
      bg = _ref$headerDesign.bg,
      padding = _ref$headerDesign.padding,
      antiAdBlocker = _ref.customCss.antiAdBlocker;

  var style = {
    padding: padding.map(function (p) {
      return "".concat(p, "px");
    }).join(" "),
    background: inheritBg ? restDesign.bg : bg,
    borderRadius: type === "dialog" ? "".concat(dialogBorderRadius, "px ").concat(dialogBorderRadius, "px 0 0") : undefined,
    position: "sticky",
    zIndex: 9,
    top: 0
  };

  if (type === "dialog" && borderWidth > 0) {
    style.borderTop = "".concat(borderWidth, "px solid ").concat(borderColor);
    style.borderLeft = style.borderTop;
    style.borderRight = style.borderTop;
  }

  return {
    className: antiAdBlocker === "y" ? undefined : "rcb-header-container",
    style: style
  };
}

export { bannerHeaderInlineStyleContainer };